var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.source != 'v2')?_c('EmptyLayout',[_vm._v(" 未找到该页面 ")]):_c('div',[_vm._v("未找到该页面")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }